import { Pipe, PipeTransform } from '@angular/core';
import { HierarchyType } from '../models/hierarchy.model';

@Pipe({
  name: 'bannerTranslate',
  standalone: true
})
export class BannerTranslatePipe implements PipeTransform {
  transform(type: HierarchyType, pending: boolean): string {
    const { Site, Sublocation, Asset } = HierarchyType;

    switch (type) {
      case Site:
        return pending
          ? $localize`Alerting pause pending on this site.`
          : $localize`Alerting paused on this site.`;
      case Sublocation:
        return pending
          ? $localize`Alerting pause pending on this sub-location.`
          : $localize`Alerting paused on this sub-location.`;
      case Asset:
        return pending
          ? $localize`Alerting pause pending on this asset.`
          : $localize`Alerting paused on this asset.`;
      default:
        return pending
          ? $localize`Alerting pause pending on this item.`
          : $localize`Alerting paused on this item.`;
    }
  }
}
